import { empConst } from '@/utils/constants';

// Tasa 105: GAS
//      4 Gas Natural
//      5 Gases Manufacturados
//      6 Gases licuados
//      7 Peajes
// Tasa 95: ELE
//      1 Tarifa
//      2 Peaje
// COMUN
//   No aplica IVA en las tasas (105 ni 95)
//   Es frecuente que las declaraciones tengan "Regularización de bases imponibles anteriores"
// GAS
//   No hay Coeficiente Reductor de la base imponible
//   Las empresas que tienen exenta la basecot 4 también tienen la 5 y viceversa
//   Ninguna empresa tiene exenciones para las basecot 6 ni 7
// ELECTRICIDAD
//   Sólo hay Coeficiente Reductor de la base imponible en la basecot 1 en suministros hasta 04-04-2009
//   Ningua empresa tiene exenciones para la tasa 95
// OBSERVACIONES GENERALES
//   Por lo que veo en BD sólo la basecot 1 puede tener CR (tanto en Tasa como en Cuota)
//
//
// CheckIntegridadDatos:
//   Que sólo haya exenciones en las basescot 4 y 5
//   Que sólo haya CR en la basecot 1 y con fefinal <= 04-04-2009 (realmente en BD la fefinal llega hasta 31/12/2008)
//
// Get:
//   Periodos de aplicación de la tasa de la empresa
//   Periodos de exenciones de la tasa para la empresa (supongo que puede venir alguna basecot que no sea 1-7)
//   Coeficientes reductores de la empresa para las basescot 4-7 y 1-2
//
// Corrige/Mejora
//   Bug en el CDBASE de Gases Manufacturado, el CDBASECO debe ser 5 no 4
//   El mes de declaración lo cojo del servidor no del cliente
//   Se valida de nuevo en el servidor:
//     - todos los percentajes y el coficiente reducto
//     - Sólo altas tasas 105 y 95 y basescot 1-7
//     - Importe a ingresar debe de ser > 0
//     - ¿las bases pueden ser negativas?

const TIPO_DECLARACION_TASA = 'T';
const TASA_TARIFA = 'TARIFA';
const TASA_PEAJE = 'PEAJE';
const TASA_PENDIENTE_PAGO = 'PG';

const tasaConst = {
  ID_TASA_GAS: 105, // TASA SECTOR HIDROCARBUROS GASEOSOS
  ID_TASA_ELE: 95, // TASA SECTOR ELECTRICO
  ID_TASA_PET: 300 // TASA SECTOR ELECTRICO
};

const tarifasPeajesInit = [
  // Tarifa y Peajes de Gas
  {
    id: 'TG1',
    tipoEmpresa: empConst.TIPO_GAS,
    idBaseCo: '4',
    idCuota: tasaConst.ID_TASA_GAS,
    tipoTasa: TASA_TARIFA,
    nombre: 'Gas natural',
    periodoConsumo: null,
    facturacion: 0,
    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'TG2',
    tipoEmpresa: empConst.TIPO_GAS,
    idBaseCo: '5',
    idCuota: tasaConst.ID_TASA_GAS,
    tipoTasa: TASA_TARIFA,
    nombre: 'Gases manufacturados',
    periodoConsumo: null,
    facturacion: 0,
    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'TG3',
    tipoEmpresa: empConst.TIPO_GAS,
    idBaseCo: '6',
    idCuota: tasaConst.ID_TASA_GAS,
    tipoTasa: TASA_TARIFA,
    nombre: 'Gases licuados del petróleo canalizados',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'PG1',
    tipoEmpresa: empConst.TIPO_GAS,
    idBaseCo: '7',
    idCuota: tasaConst.ID_TASA_GAS,
    tipoTasa: TASA_PEAJE,
    nombre: 'Suministros hasta 04-04-2009',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'PG2',
    tipoEmpresa: empConst.TIPO_GAS,
    idBaseCo: '7',
    idCuota: tasaConst.ID_TASA_GAS,
    tipoTasa: TASA_PEAJE,
    nombre: 'Suministros entre 05-04-2009 y 31-03-2012',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'PG3',
    tipoEmpresa: empConst.TIPO_GAS,
    idBaseCo: '7',
    idCuota: tasaConst.ID_TASA_GAS,
    tipoTasa: TASA_PEAJE,
    nombre: 'Suministros desde 01-04-2012',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  // Tarifa y Peajes de Electricidad
  {
    id: 'TE1',
    tipoEmpresa: empConst.TIPO_ELE,
    idBaseCo: '1',
    idCuota: tasaConst.ID_TASA_ELE,
    tipoTasa: TASA_TARIFA,
    nombre: 'Suministros hasta 04-04-2009',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'TE2',
    tipoEmpresa: empConst.TIPO_ELE,
    idBaseCo: '1',
    idCuota: tasaConst.ID_TASA_ELE,
    tipoTasa: TASA_TARIFA,
    nombre: 'Suministros entre 05-04-2009 y 30-06-2009',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'PE1',
    tipoEmpresa: empConst.TIPO_ELE,
    idBaseCo: '2',
    idCuota: tasaConst.ID_TASA_ELE,
    tipoTasa: TASA_PEAJE,
    nombre: 'Suministros hasta 04-04-2009',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'PE2',
    tipoEmpresa: empConst.TIPO_ELE,
    idBaseCo: '2',
    idCuota: tasaConst.ID_TASA_ELE,
    tipoTasa: TASA_PEAJE,
    nombre: 'Suministros entre 05-04-2009 y 31-03-2012',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: 0,
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  },
  {
    id: 'PE3',
    tipoEmpresa: empConst.TIPO_ELE,
    idBaseCo: '2',
    idCuota: tasaConst.ID_TASA_ELE,
    tipoTasa: TASA_PEAJE,
    nombre: 'Suministros desde 01-04-2012',
    periodoConsumo: null,
    facturacion: 0,

    baseImponible: '',
    cuotaTributaria: 0,
    tipo: '',
    selected: false
  }
];

const liquidacionesTarifasPeajesInit = [
  // Liquidaciones de Tarifas y Peajes de Gas
  {
    id: 'TG',
    tipoEmpresa: empConst.TIPO_GAS,
    nombre: 'Base imponible TARIFA',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: ''
  },
  {
    id: 'PG1',
    tipoEmpresa: empConst.TIPO_GAS,
    nombre: 'Base imponible PEAJE hasta 04-04-2009',
    tipo: 0,
    baseImponible: '',
    cuotaTributaria: ''
  },
  {
    id: 'PG2',
    tipoEmpresa: empConst.TIPO_GAS,
    nombre: 'Base imponible PEAJE entre 05-04-2009 y 31-03-2012',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: ''
  },
  {
    id: 'PG3',
    tipoEmpresa: empConst.TIPO_GAS,
    nombre: 'Base imponible PEAJE desde 01-04-2012',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: ''
  },
  {
    id: 'RG',
    tipoEmpresa: empConst.TIPO_GAS,
    nombre: 'Regularización bases imponibles anteriores',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: 0
  },
  // Liquidaciones de Tarifjas y Pajes de Electricidad
  {
    id: 'TE1',
    tipoEmpresa: empConst.TIPO_ELE,
    nombre: 'Base imponible TARIFA hasta 04-04-2009',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: 0
  },
  {
    id: 'TE2',
    tipoEmpresa: empConst.TIPO_ELE,
    nombre: 'Base imponible TARIFA entre 05-04-2009 y 30-06-2009',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: 0
  },
  {
    id: 'PE1',
    tipoEmpresa: empConst.TIPO_ELE,
    nombre: 'Base imponible PEAJE hasta 04-04-2009',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: 0
  },
  {
    id: 'PE2',
    tipoEmpresa: empConst.TIPO_ELE,
    nombre: 'Base imponible PEAJE entre 05-04-2009 y 31-03-2012',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: 0
  },
  {
    id: 'PE3',
    tipoEmpresa: empConst.TIPO_ELE,
    nombre: 'Base imponible PEAJE desde 01-04-2012',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: 0
  },
  {
    id: 'RE',
    tipoEmpresa: empConst.TIPO_ELE,
    nombre: 'Regularización bases imponibles anteriores',
    tipo: 0,
    baseImponible: 0,
    cuotaTributaria: 0
  }
];

export {
  TASA_TARIFA,
  TASA_PEAJE,
  TIPO_DECLARACION_TASA,
  TASA_PENDIENTE_PAGO,
  tarifasPeajesInit,
  liquidacionesTarifasPeajesInit,
  tasaConst
};
